import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42ab653f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paid-vip-box" }
const _hoisted_2 = {
  key: 0,
  class: "tips-box"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box inline-tips-box" }, "未过期则在原到期时间上叠加，已过期从当前时间算", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-box" }, "以这个时间直接覆盖原到期时间，可能比原来短", -1))
const _hoisted_5 = { class: "operat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-width": "100px",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_form_item, {
          label: "用户",
          style: {"margin-bottom":"8px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data?.name || _ctx.data?.phone || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, {
          label: "当前会员",
          style: {"margin-bottom":"8px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.currentVipText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, {
          label: "会员等级",
          required: true,
          data: _ctx.postData.levelId,
          error: "请选择会员等级"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.postData.levelId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postData.levelId) = $event)),
              placeholder: "请选择会员等级",
              disabled: !!_ctx.activeLevelId,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: `VIP${index + 1} ${item.name || ''}`,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            (_ctx.activeLevelId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, "该用户会员未到期，只能续同一等级"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_ui_form_item, { label: "赠送方式" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.postData.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postData.type) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode("按月赠送")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode("指定到期时间")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.postData.type == 0)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 0,
              label: "赠送月数",
              required: true,
              data: _ctx.postData.month,
              rule: _ctx.validateMonth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.postData.month,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postData.month) = $event)),
                  min: 1,
                  max: 120,
                  style: {"width":"160px"}
                }, null, 8, ["modelValue"]),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["data", "rule"]))
          : (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 1,
              label: "到期时间",
              required: true,
              data: _ctx.postData.endDate,
              error: "请选择到期时间"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.postData.endDate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.postData.endDate) = $event)),
                  type: "datetime",
                  placeholder: "请选择到期时间"
                }, null, 8, ["modelValue"]),
                _hoisted_4
              ]),
              _: 1
            }, 8, ["data"])),
        _createVNode(_component_ui_form_item, { label: "备注" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              rows: 3,
              maxlength: "100",
              modelValue: _ctx.postData.remark,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.postData.remark) = $event)),
              placeholder: "会记进会员操作流水"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                onClick: _ctx.submit,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_loading, _ctx.submitLoading]
              ]),
              _createVNode(_component_el_link, {
                onClick: _ctx.close,
                underline: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}